import React from "react"
import {bindActionCreators} from "redux"
import {connect} from "react-redux"
import Helmet from "react-helmet"
import * as MyActions from "./MyProposalsApi"
import Dollars from "../../components/Dollars"
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table"
import Select from 'react-select'
import _ from 'lodash'
import './MyProposals.scss'
import {
    Button,
    Col,
    ControlLabel,
    FormGroup,
    Grid,
    MenuItem,
    Nav,
    NavDropdown,
    OverlayTrigger,
    Row,
    Tooltip,
    Well,
} from "react-bootstrap"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {faInfoCircle} from "@fortawesome/free-solid-svg-icons"
import {LinkContainer} from "react-router-bootstrap"

import moment from "moment/moment"
import {defaultDateFormat, defaultDateFormatShort, saveNewCsvDownload, select} from "../../common/commonHandlers";
import ResourceComponent from "../../components/ResourceComponent";
import {DateRangePicker} from "react-dates";
import {withMediaQuery} from '../../utilities/hooks/useMediaQuery';

const Actions = {...MyActions, saveNewCsvDownload}
const statusOptions = [
    {value: 'all', label: 'All'},
    {value: 'open', label: 'Open'},
    {value: 'closed', label: 'Closed'}
];

class MyProposals extends ResourceComponent {
    state = {
        resource: {
            page: 1,
            perPage: 25,
            query: "",
            status: "all"
        },
        myProposals: [],
        stats: null,
        loading: false,
        totalEntries: 0,
        selectedRows: []
    }

    tableRef = React.createRef()

    componentDidMount() {
        this.setState({loading: true})
        this.props.actions.load(response => this.setState({...response, loading: false}))
    }

    render() {
        const {salesArboristId, proposalProposedStart, proposalProposedEnd, status} = this.state.resource
        const {myProposals, salesArborists, totalEntries, stats} = this.state
        const {isMobile} = this.props

        return (
            <Grid fluid className="my-proposals">
                <Helmet title="My Proposals"/>
                <form onSubmit={this.fetchMyProposals}>
                    <Row>
                        <Col md={6}>
                            <h3 className="text-primary" style={{marginBottom: "0px", marginTop: "0px"}}>
                                My Proposals {totalEntries} found.
                            </h3>
                            <FormGroup bsSize="sm">
                                <Row>
                                    <ControlLabel>
                                        {" "}&nbsp;
                                    </ControlLabel>
                                    <br/>
                                    <Col md={5}>
                                        <DateRangePicker
                                            startDate={proposalProposedStart ? moment.utc(proposalProposedStart) : null}
                                            startDateId="proposalStartDate"
                                            endDate={proposalProposedEnd ? moment.utc(proposalProposedEnd) : null}
                                            endDateId="proposalEndDate"
                                            keepOpenOnDateSelect={true}
                                            showClearDates={true}
                                            reopenPickerOnClearDate={true}
                                            onDatesChange={({startDate, endDate}) => {
                                                this.dateResourceAttr('proposalProposedStart')(startDate);
                                                this.dateResourceAttr('proposalProposedEnd')(endDate);
                                            }}
                                            focusedInput={this.state.focusedInput}
                                            onFocusChange={focusedInput => this.setState({focusedInput})}
                                            isOutsideRange={() => false}
                                            minimumNights={0}
                                            startDatePlaceholderText="Start Date"
                                            endDatePlaceholderText="End Date"
                                            displayFormat={defaultDateFormat}
                                            orientation={isMobile ? 'vertical' : 'horizontal'}
                                        />
                                    </Col>

                                    <Col md={4}>
                                        <Select className="Select" classNamePrefix="select"
                                                name="sales-arborist-select"
                                                value={select(salesArborists, salesArboristId)}
                                                options={salesArborists}
                                                onChange={this.selectResourceAttr('salesArboristId')}
                                                placeholder="Sales Arborist"
                                                isClearable
                                        />
                                    </Col>
                                    <Col md={2}>
                                        <Select
                                            className="Select"
                                            classNamePrefix="select"
                                            name="status-select"
                                            value={statusOptions.find(option => option.value === status)}
                                            options={statusOptions}
                                            onChange={selectedOption => {
                                                const {resource} = this.state;
                                                resource.status = selectedOption.value;
                                                this.setState({resource});
                                            }}
                                            placeholder="Status"
                                        />
                                    </Col>
                                    <OverlayTrigger placement="right" overlay={
                                        <Tooltip id="date-filter-tooltip">
                                            <div className="text-left">
                                                <p><strong>Open</strong> - filters by Created Date</p>
                                                <p><strong>Closed</strong> - filters by Accepted Date</p>
                                                <p><strong>All</strong> - for closed proposals, filters by Accepted
                                                    Date;
                                                    for open proposals, filters by Created Date</p>
                                            </div>
                                        </Tooltip>
                                    }>
                                        <FontAwesomeIcon icon={faInfoCircle} className="font16"/>
                                    </OverlayTrigger>
                                </Row>
                                <Button bsSize="small" type="submit" bsStyle="success" className="mt-20"
                                        disabled={this.state.loading}>
                                    Find Proposals
                                </Button>
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            {stats && (
                                <Well style={{paddingBottom: 0, marginBottom: 0, paddingTop: 5}}>
                                    <Row>
                                        <Col md={12}>
                                            <Col md={4} className="text-left text-primary">
                                                Close Rate <br/>
                                                By Number: <span>{`${stats.close_rate_by_number}%`}</span>
                                                <br/>
                                                By Dollars: <span>{`${stats.close_rate_by_dollars}%`}</span>
                                            </Col>
                                            <Col md={2} className="text-right text-warning">
                                                <Row>
                                                    {`Bids: ${stats.bids_count}`} <br/>
                                                    <Dollars amount={stats.bids_total}/>
                                                </Row>
                                                <Row>
                                                    Tree <br/>
                                                    <Dollars amount={stats.tree_total}/>
                                                </Row>
                                                <Row>
                                                    PHC <br/>
                                                    <Dollars amount={stats.phc_total}/>
                                                </Row>
                                            </Col>
                                            <Col md={3} className="text-right text-info">
                                                <Row>
                                                    {`Closed: ${stats.closed_count}`} <br/>
                                                    <Dollars amount={stats.closed_total}/>
                                                </Row>
                                                <Row>
                                                    Tree <br/>
                                                    <Dollars amount={stats.closed_tree}/>
                                                </Row>
                                                <Row>
                                                    PHC <br/>
                                                    <Dollars amount={stats.closed_phc}/>
                                                </Row>
                                            </Col>

                                            <Col md={3} className="text-right text-success">
                                                <Row>
                                                    {`Open: ${stats.open_count}`} <br/>
                                                    <Dollars amount={stats.open_total}/>
                                                </Row>
                                                <Row>
                                                    Tree <br/>
                                                    <Dollars amount={stats.open_tree}/>
                                                </Row>
                                                <Row>
                                                    PHC <br/>
                                                    <Dollars amount={stats.open_phc}/>
                                                </Row>
                                            </Col>

                                            <Row>
                                                <Col md={6}>
                                                    <h6 className="text-left text-danger">
                                                        Declined Services: <Dollars amount={stats.declined_total}/>
                                                    </h6>
                                                </Col>
                                                <Col md={8}>
                                                    {["all", "open"].includes(status) && (
                                                        <h6 className="text-right text-danger">
                                                            {`${stats.avg_age_open_bids.toFixed(1)} average Age for ${stats.open_count} open bids`}
                                                        </h6>
                                                    )}
                                                    {["all", "closed"].includes(status) && (
                                                        <h6 className="text-right text-danger">
                                                            {`${stats.avg_days_to_close.toFixed(1)} average Days To Close for ${stats.closed_count} won bids`}
                                                        </h6>
                                                    )}
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Well>
                            )}
                        </Col>

                    </Row>
                </form>
                <p>&nbsp;</p>

                <Row>
                    <Col md={12}>
                        {myProposals ? this._renderTable(myProposals) : null}
                    </Col>
                </Row>

                <Row>
                    <Col md={12}/>
                </Row>

            </Grid>
        )
    }

    fetchMyProposals = (e, fetchStats = true) => {
        const {resource} = this.state;
        e && e.preventDefault()
        const newResource = {...resource}
        if (fetchStats) {
            newResource.page = 1;
        }
        this.setState({loading: true, resource: newResource});
        this.props.actions.fetchMyProposals(newResource, response => {
            if (fetchStats) {
                this.props.actions.fetchMyProposalsStats(newResource, stats => this.setState({stats}))
            }
            this.setState({
                myProposals: response.proposals,
                totalEntries: response.total_entries,
                loading: false
            })
        })
    }

    handleSearch = (state, setState) => {
        this.props.actions.fetchMyProposals(state.resource, response => {
            setState && setState({
                myProposals: response.proposals,
                totalEntries: response.total_entries,
                loading: false
            })

        })

    }
    debouncedSearch = _.debounce(this.handleSearch, 500)

    onSearchChange = text => {
        this.setState({
            resource: {
                ...this.state.resource,
                query: text
            }
        }, () => this.debouncedSearch(this.state, (newState) => this.setState(newState)));
    }

    _dateFormatter = cell => cell ? moment(cell).format(defaultDateFormatShort) : ""

    _dollarFormatter = cell => <Dollars amount={cell}/>

    _csvDollarFormatter = cell => {
        return parseFloat(cell ? cell : 0).toFixed(2)
    }

    _phoneFormatter = (cell) => {
        const {isMobile} = this.props;
        return cell && isMobile ? <a media="screen" href={`tel:${cell.replace(/\\D/g, '')}`}>
            {cell}
        </a> : <>{cell}</>
    }
    updateSorting = (sortBy, sort) => {
        let {resource} = this.state;
        resource = {...resource, sortBy, sort};
        this.setState({
            resource,
            loading: true
        }, () => this.debouncedSearch(this.state, (newState) => this.setState(newState)));
    }

    onExportToCSV = () => {
        const {myProposals} = this.state
        const selectedRows = this.state.selectedRows;
        return myProposals.filter(i => {
            if (selectedRows.indexOf(i.proposalNo) > -1) {
                return i;
            }
        });
    }

    onRowSelect = (row, isSelected) => {
        let selectedRows = [...this.state.selectedRows];
        if (isSelected) {
            selectedRows = selectedRows.concat(row.proposalNo);
            const uniqSelected = new Set(selectedRows);
            selectedRows = [...uniqSelected];
        } else {
            selectedRows = selectedRows.filter(s => s !== row.proposalNo);
        }
        this.setState({selectedRows});
    };

    onSelectAll = (isSelected, rows) => {
        let selectedRows = [];

        if (isSelected) {
            selectedRows = rows.map(p => p.proposalNo)
        }
        this.setState({selectedRows})
    };

    _renderTable = data => {
        const options = {
            sizePerPageDropDown: this.renderSizePerPageDropDown,
            page: this.state.resource.page,
            sizePerPageList: [{
                text: '10', value: 10
            }, {
                text: '25', value: 25
            }, {
                text: '30', value: 30
            }, {
                text: '50', value: 50
            }, {
                text: '100', value: 100
            }, {
                text: '200', value: 200
            }],
            sizePerPage: this.state.resource.perPage,
            paginationSize: 3,
            onPageChange: (page, perPage) => {
                let {resource} = this.state;
                resource = {...resource, page, perPage};
                this.setState({resource}, () => this.fetchMyProposals(null, false));
            },
            onSearchChange: this.onSearchChange,
            clearSearch: true,
            sortName: this.state.resource.sortBy,
            sortOrder: this.state.resource.sort,
            onSortChange: this.updateSorting,
            onExportToCSV: this.onExportToCSV,
            exportCSVBtn: (onClick) => <Button onClick={onClick} bsStyle="success"
                                               disabled={this.state.selectedRows.length === 0}>Export to CSV</Button>
        }
        return (
            <div style={this.state.loading ? {pointerEvents: 'none', opacity: 0.5} : {}}>
                <BootstrapTable
                    ref={this.tableRef}
                    data={data}
                    options={options}
                    striped={true}
                    bordered={false}
                    hover={true}
                    exportCSV={true}
                    pagination
                    remote
                    search
                    className="wrapped"
                    fetchInfo={{dataTotalSize: this.state.totalEntries}}
                    csvFileName={() => {
                        const fileName = `proposals-${moment().format()}.csv`
                        if (this.tableRef?.current) {
                            this.props.actions.saveNewCsvDownload(this.tableRef.current, fileName, this.state.resource, "my proposals")
                        }
                        return fileName
                    }}
                    selectRow={{
                        mode: "checkbox",
                        clickToSelect: false,
                        onSelect: this.onRowSelect,
                        onSelectAll: this.onSelectAll,
                        selected: (() => {
                            return this.state.selectedRows
                        })()

                    }}
                >
                    <TableHeaderColumn
                        dataField="name"
                        tdStyle={{whiteSpace: 'normal'}}
                        thStyle={{whiteSpace: 'normal'}}
                        dataFormat={this._linkFormatter}
                        dataSort={true}
                        columnClassName='menu-show-fixer'
                    >
                        Customer Name
                    </TableHeaderColumn>

                    <TableHeaderColumn
                        tdStyle={{whiteSpace: 'normal'}}
                        thStyle={{whiteSpace: 'normal'}}
                        dataField="arborist"
                        dataSort={true}
                    >
                        Arborist
                    </TableHeaderColumn>

                    <TableHeaderColumn
                        tdStyle={{whiteSpace: 'normal'}}
                        thStyle={{whiteSpace: 'normal'}}
                        dataField="siteAddress"
                        dataSort={true}
                    >
                        Site Address
                    </TableHeaderColumn>

                    <TableHeaderColumn
                        dataField="proposedDate"
                        dataFormat={this._dateFormatter}
                        csvFormat={this._dateFormatter}
                        dataSort={true}>
                        Proposal Date
                    </TableHeaderColumn>

                    <TableHeaderColumn
                        dataField="acceptedDate"
                        dataFormat={this._dateFormatter}
                        csvFormat={this._dateFormatter}
                        dataSort={true}>
                        Accepted Date
                    </TableHeaderColumn>

                    <TableHeaderColumn
                        dataField="proposalNo"
                        dataFormat={this._proposalLinkFormatter}
                        isKey={true}
                        dataSort={true}
                        columnClassName='menu-show-fixer'
                    >
                        Proposal No
                    </TableHeaderColumn>

                    <TableHeaderColumn
                        dataField="proposalTotal"
                        dataFormat={this._dollarFormatter}
                        csvFormat={this._csvDollarFormatter}
                        dataSort={true}>
                        Proposal Total
                    </TableHeaderColumn>

                    <TableHeaderColumn
                        tdStyle={{whiteSpace: 'normal', wordBreak: 'break-word'}}
                        thStyle={{whiteSpace: 'normal'}}
                        dataField="email"
                        dataSort={true}
                    >
                        Email
                    </TableHeaderColumn>

                    <TableHeaderColumn dataField="phone" dataSort={true} dataFormat={this._phoneFormatter}>
                        Contact Phone
                    </TableHeaderColumn>

                    <TableHeaderColumn
                        dataField="age"
                        dataSort={true}>
                        Age
                    </TableHeaderColumn>
                </BootstrapTable>
            </div>
        )
    }

    _linkFormatter = (cell, row) => (
        <Nav>
            <NavDropdown
                eventKey={2}
                title={`${row.name}`}
                id={`proposal-menu`}
                className="menu-show-fixer proposal-menu-padding-reset"
            >
                <LinkContainer to={`/customer/info/${row.id}`}>
                    <MenuItem bsSize="small">Info</MenuItem>
                </LinkContainer>
                <LinkContainer to={`/customer/proposals/${row.id}`}>
                    <MenuItem bsSize="small">Proposals</MenuItem>
                </LinkContainer>
                <LinkContainer to={`/customer/sites/${row.id}`}>
                    <MenuItem bsSize="small">Sites</MenuItem>
                </LinkContainer>
                <LinkContainer to={`/customer/work_orders/${row.id}`}>
                    <MenuItem bsSize="small">Work Orders</MenuItem>
                </LinkContainer>
                <LinkContainer to={`/customer/invoices/${row.id}`}>
                    <MenuItem bsSize="small">Invoices</MenuItem>
                </LinkContainer>
                <LinkContainer to={`/customer/work_history/${row.id}`}>
                    <MenuItem bsSize="small">Work History</MenuItem>
                </LinkContainer>
            </NavDropdown>
        </Nav>
    )

    _proposalLinkFormatter = (cell, row) => (
        <Nav>
            <NavDropdown
                eventKey={2}
                title={cell}
                id={`proposal-menu`}
                className="menu-show-fixer proposal-menu-padding-reset"
            >
                <LinkContainer to={`/mapview/${row.proposalId}`}>
                    <MenuItem bsSize="small">Edit Proposal</MenuItem>
                </LinkContainer>
                <LinkContainer to={`/proposal_service_status/${row.proposalId}`}>
                    <MenuItem bsSize="small">Proposal Statuses</MenuItem>
                </LinkContainer>
                <LinkContainer to={`/print_proposal/${row.proposalId}`}>
                    <MenuItem bsSize="small">Print Proposal</MenuItem>
                </LinkContainer>
            </NavDropdown>
        </Nav>
    )

}

function mapStateToProps(state) {
    return {}
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Actions, dispatch)
    }
}

const MyProposalsWithMedia = withMediaQuery(MyProposals, {
    isMobile: {maxWidth: 991},
});

export default connect(mapStateToProps, mapDispatchToProps)(MyProposalsWithMedia)
